"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Day = /** @class */ (function (_super) {
    __extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function () {
            var _a = _this.props, day = _a.day, from = _a.from, to = _a.to;
            var classes = 'day';
            if (day.isToday) {
                classes += ' today';
            }
            if (!day.isCurrentMonth) {
                classes += ' different-month';
            }
            if (day.disabled) {
                classes += ' disabled';
            }
            if (_this.isSelected()) {
                classes += ' selected';
            }
            if (from && day.date.isSame(from, 'day')) {
                classes += ' start';
            }
            if (to && day.date.isSame(to, 'day')) {
                classes += ' end';
            }
            return classes;
        };
        _this.isSelected = function () {
            var _a = _this.props, selected = _a.selected, from = _a.from, to = _a.to, day = _a.day;
            if (selected && day.date.isSame(selected, 'day')) {
                return true;
            }
            if ((from && !to) && day.date.isSame(from, 'day')) {
                return true;
            }
            if ((from && to) && (day.date.isSameOrBefore(to, 'day') && day.date.isSameOrAfter(from, 'day'))) {
                return true;
            }
            return false;
        };
        return _this;
    }
    Day.prototype.render = function () {
        var _a = this.props, day = _a.day, select = _a.select;
        return (React.createElement("span", { key: day.date.toISOString(), className: this.genClasses(), onClick: function () { return !day.disabled && select(day.date); } }, day.number && day.isCurrentMonth ? day.number : ''));
    };
    return Day;
}(react_1.Component));
exports.default = Day;
